import { put, select, takeLatest } from 'redux-saga/effects'
import { QuickActionsConstants } from '../store/quickActions.constants'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import {
  setIsVitalButtonType,
  setIsMedicationButtonType,
  setIsProcedureButtonType,
  setIsCardiacButtonType,
  setIsIntubationButtonType,
  setIsAirwayButtonType,
  setIsChildbirthOBButtonType,
  setIsExtricationButtonType,
  setIsHospitalNotifyButtonType,
  setIsInitiateIVButtonType,
  setIsImmobilizationButtonType,
  setIsMedicalConsultButtonType,
  setIsOperationsButtonType,
  setIsVentilatorButtonType,
  setIsWoundCareButtonType,
  setIsRescueButtonType,
  setIsDrainButtonType,
  setIsTitrateButtonType,
  setIsLabsButtonType,
  setIsBloodProductAdministrationButtonType,
  setIsVentricularAssistDeviceButtonType,
  setIsCriticalCareButtonType,
} from '../store/quickActions.actions'
import { resetTitrateState } from '../../procedures/titrate/store/titrate.actions'
import { resetState } from '../../procedures/drain/store/drain.actions'
import { resetState as resetBloodProductAdministrationState } from '../../procedures/bloodProductAdministration/store/bloodProductAdministration.actions'
import { addMedicationAdministered } from '../../addMedicationAdministered/store/addMedicationAdministered.actions'
import { resetLabsState } from '../../procedures/labs/store/labs.actions'
import { resetState as resetVentricularAssistDeviceState } from '../../procedures/ventricularAssistDevice/store/ventricularAssistDevice.actions'
import { resetState as resetCriticalCareState } from '../../procedures/criticalCare/store/criticalCare.actions'

export function* setSelectedQuickActionButtonType() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { selectedQuickActionButton } = quickActionsObject
  const { procName } = selectedQuickActionButton
  if (procName === 'Medication') {
    yield put(addMedicationAdministered())
    yield put(setIsMedicationButtonType())
  } else if (procName === null) {
    yield put(setIsVitalButtonType())
  } else if (procName === 'Cardiac') {
    yield put(setIsCardiacButtonType())
  } else if (procName === 'Intubation') {
    yield put(setIsIntubationButtonType())
  } else if (procName === 'Airway') {
    yield put(setIsAirwayButtonType())
  } else if (procName === 'Childbirth') {
    yield put(setIsChildbirthOBButtonType())
  } else if (procName === 'Extrication') {
    yield put(setIsExtricationButtonType())
  } else if (procName === 'Hosp. Notify') {
    yield put(setIsHospitalNotifyButtonType())
  } else if (procName === 'Initiate IV') {
    yield put(setIsInitiateIVButtonType())
  } else if (procName === 'Immobilization') {
    yield put(setIsImmobilizationButtonType())
  } else if (procName === 'Medical Consult') {
    yield put(setIsMedicalConsultButtonType())
  } else if (procName === 'Operations') {
    yield put(setIsOperationsButtonType())
  } else if (procName === 'Rescue') {
    yield put(setIsRescueButtonType())
  } else if (procName === 'Ventilator') {
    yield put(setIsVentilatorButtonType())
  } else if (procName === 'Wound Care') {
    yield put(setIsWoundCareButtonType())
  } else if (procName === 'Drain') {
    yield put(resetState())
    yield put(setIsDrainButtonType())
  } else if (procName === 'Titrate') {
    yield put(resetTitrateState())
    yield put(setIsTitrateButtonType())
  } else if (procName === 'Labs') {
    yield put(resetLabsState())
    yield put(setIsLabsButtonType())
  } else if (procName === 'Blood Administration') {
    yield put(resetBloodProductAdministrationState())
    yield put(setIsBloodProductAdministrationButtonType())
  } else if (procName === 'VAD') {
    yield put(resetVentricularAssistDeviceState())
    yield put(setIsVentricularAssistDeviceButtonType())
  } else if (procName === 'Critical Care') {
    yield put(resetCriticalCareState())
    yield put(setIsCriticalCareButtonType())
  } else {
    yield put(setIsProcedureButtonType())
  }
}
export function* setSelectedQuickActionButtonTypeSaga() {
  yield takeLatest([QuickActionsConstants.SET_SELECTED_QUICK_ACTION_BUTTON_TYPE], setSelectedQuickActionButtonType)
}
